define('LearningLibrarySearchResults/searchCount',[     
],
    function () {
       
        function displayCountResults(count, keyword, tagsInfo) {          
            if (!$("#searchCount").length) return;
            if (count)
                $("#searchCount").html($("#searchCountComponent").data("resultsCountText").replace("{count}", count));
            if (keyword)
                $("#searchKeywordTag").html($("#searchCountComponent").data("resultsKeywordText").replace("{keywords}", generateTagSpans(keyword, null)));
            else
                $("#searchKeywordTag").html("");           
            if (tagsInfo && tagsInfo.length > 0)
                $("#searchTags").html($("#searchCountComponent").data("resultsTagsText").replace("{tags}", generateTagSpans(null, tagsInfo)));
            else
                $("#searchTags").html("");
        }

        tagSpanClick = function (element) { 
            var id = $(element).data("value");           
            if ($(element).hasClass("remove-keyboard-span")) {
                $("#searchkeywordstxt").val("");
                $("#searchkeywordicon").trigger("click");               
            }
            else if ($(element).hasClass("remove-tag-span")) {              
                $("#" + id).trigger("click");                 
            }            

            $(element).parent().remove();
        }

        function generateTagSpans(keyword, tags) {           
            var tagSpans = "";
            if (keyword) {
                tagSpans = '<span class="facet-breadcrumb"><span class="value">' + keyword + '</span><i class="icon icon-plus close-button remove-keyboard-span" onclick="tagSpanClick(this);" data-name="Keyword" data-value="' + keyword + '"></i></span>';
            }
            if (tags) {
                for (var i = 0; i < tags.length; i++) {
                    var tagInfo = tags[i];
                    tagSpans += '<span class="facet-breadcrumb"><span class="name">' + tagInfo.TagGroupName + ': </span><span class="value">' + tagInfo.TagText + '</span><i class="icon icon-plus close-button remove-tag-span" onclick="tagSpanClick(this);" data-name="Keyword" data-value="' + tagInfo.TagId + '"></i></span>';
                }
            }

            return tagSpans;
        }

        return {
            displayCountResults: displayCountResults
        };
});

